import { Component } from '@angular/core';

@Component({
    selector: 'bb-file-attachment-page-ui',
    template: '',
    standalone: false,
})
export class FileAttachmentPageComponent {}
